const REDUCED_MOTION_SPEED_SCALE = 1 / 1.5;

export function getBackgroundMotionScale(prefersReducedMotion) {
  return prefersReducedMotion ? REDUCED_MOTION_SPEED_SCALE : 1;
}

export function getBackgroundAnimationTime(elapsedMilliseconds, speed, prefersReducedMotion) {
  const motionScale = getBackgroundMotionScale(prefersReducedMotion);
  return (elapsedMilliseconds / 1000) * speed * motionScale;
}
